export default __webpack_public_path__ + "static/media/List-documentation.acf2dc61.md";